'use client'

import {getSession} from 'next-auth/react'

let isRefreshing = false
const queue: ((
  tokens: {newAccessToken: string; newRefreshToken: string} | null
) => void)[] = []

export async function refreshTokenClient(): Promise<{
  newAccessToken: string
  newRefreshToken: string
} | null> {
  const session = await getSession()

  console.log(isRefreshing)

  if (isRefreshing) {
    return new Promise(resolve => {
      queue.push(resolve)
    })
  }

  isRefreshing = true

  if (!session?.refreshToken) {
    window.location.href = '/login?authentication=expired'
    return null
  }
  const response = await fetch('/api/refresh-token', {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify({
      session,
    }),
  })
  if (!response.ok) {
    window.location.href = '/login?authentication=refresh-token-failed'
    return null
  }
  const {newAccessToken, newRefreshToken} = await response.json()
  isRefreshing = false
  queue.forEach(resolve => resolve({newAccessToken, newRefreshToken}))
  return {newAccessToken, newRefreshToken}
}
